import { render, staticRenderFns } from "./dynamic-po.vue?vue&type=template&id=839f634e&scoped=true&"
import script from "./dynamic-po.vue?vue&type=script&lang=js&"
export * from "./dynamic-po.vue?vue&type=script&lang=js&"
import style0 from "./dynamic-po.vue?vue&type=style&index=0&id=839f634e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "839f634e",
  null
  
)

export default component.exports